import React from "react";

const disableEvent = {
  pointerEvents: "none",
  opacity: "0.6",
  cursor: "not-allowed",
};

const CardWrapper = ({ title, titleExtra, children, isDisabledOrder }) => {
  return (
    <div
      className="card shadow-sm border-0 rounded-4 py-4 px-3 mb-4"
      id="addOnAccordion"
      style={isDisabledOrder ? disableEvent : {}}
    >
      <div className="d-flex justify-content-between align-items-center pb-3">
        <h5 className="mb-0 fw-bold">{title}</h5>
        {titleExtra && (
          <div className="title-extra">
            {titleExtra}
          </div>
        )}
      </div>
      <div className="card-body px-3">{children}</div>
    </div>
  );
};

export default CardWrapper;
